










































































































































































































































































































































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import moment from "moment";
import DokterAutoComplete from "@/components/pemeriksaan/assesmen/DokterAutoComplete.vue";
import UnitAutoComplete from "@/components/pemeriksaan/assesmen/UnitAutoComplete.vue";
import TransferInternal from "@/services/TransferInternal";
import { PtiDiterimaResponseItem, PtiTransferResponseItem } from "@/types/pti";
import storeReferensiUnit from "@/store/modules/new/ReferensiUnit";
import PenerimaanTransferInternal from "@/components/pti/PenerimaanTransferInternal.vue";
import PengirimanTransferInternal from "@/components/pti/PengirimanTransferInternal.vue";
import DialogVerifikasiSampai from "@/components/pti/DialogVerifikasiSampai.vue";

@Component({
  components: {
    DokterAutoComplete,
    UnitAutoComplete,
    PenerimaanTransferInternal,
    PengirimanTransferInternal,
    DialogVerifikasiSampai
  }
})
export default class ListTransfer extends Vue {
  @Prop({ default: "Daftar Pasien Transfer Internal" }) readonly title: string;
  @Prop({ default: "Transfer" }) readonly type: string;
  @Prop({ default: "received" }) readonly mode: string;
  @Prop({ default: "200px" }) readonly tableHeight: string;

  selectedId = null;
  modalPenerimaan = false;
  dialogTransfer = false;
  modalPengiriman = false;
  selectedTransferId = 0;
  modalDetail = false;
  today = moment().format("YYYY-MM-DD");
  minDate = moment()
    .subtract(3, "days")
    .format("YYYY-MM-DD");
  data = {};
  dokter = {};
  unit = {};
  loadingList = false;
  errorList = "0";
  listData: Array<PtiDiterimaResponseItem | PtiTransferResponseItem> = [];
  selectedTransfer:
    | PtiDiterimaResponseItem
    | PtiTransferResponseItem
    | null = null;
  selectedRegister = 0;
  isEditMode = false;
  isUserLoaded = false;
  to_user_id = 0;
  selectedPasienRm = "";
  selectedFromUnit: any = null;
  selectedIdTransfer = null;

  listKualifikasi = [
    { text: "dr. Spesialis", value: "1" },
    { text: "Dokter", value: "2" },
    { text: "Perawat/ Bidan PRA PK/ PRA BK", value: "3" },
    { text: "Perawat/ Bidan PK 1/ BK 1", value: "4" },
    { text: "Perawat/ Bidan PK 2/ BK 2", value: "5" },
    { text: "Perawat/ Bidan PK 3/ BK 3", value: "6" },
    { text: "Perawat/ Bidan PK 4/ BK 4", value: "7" },
    { text: "Penata Anestesi", value: "8" }
  ];

  getKualifikasiText(value: string | null): string {
    if (!value) return "-";
    const item = this.listKualifikasi.find(k => k.value === value);
    return item ? item.text : "-";
  }

  getYaTidakText(value: boolean | null | undefined): string {
    if (value === true) return "Ya";
    if (value === false) return "Tidak";
    return "-";
  }

  getApgarScoreText(klinis: any): string {
    if (!klinis || !klinis.apgarscore) return "-";

    const menit1 = klinis.apgarscore["1"];
    const menit5 = klinis.apgarscore["5"];

    const parts: string[] = [];
    if (menit1 !== null && menit1 !== undefined) {
      parts.push(`Menit 1: ${menit1}`);
    }
    if (menit5 !== null && menit5 !== undefined) {
      parts.push(`Menit 5: ${menit5}`);
    }

    return parts.length > 0 ? parts.join(", ") : "";
  }

  get showPenjemput(): boolean {
    const item = this.selectedTransfer;

    return !!item && (!!item.pickup_user_id || !!item.pickup_at);
  }

  get pengirimanReadonly() {
    if (!this.selectedTransfer) return false;

    return !this.canEditPengiriman(this.selectedTransfer);
  }

  get penerimaanReadonly() {
    if (!this.selectedTransfer) return true;

    return !this.selectedTransfer.can_receive;
  }

  get loadingListData() {
    return this.loadingList;
  }

  get uniqueKey() {
    return "id";
  }

  showArrivedModal = false;
  verifying = false;
  arrivedTarget: any = null;

  get headers() {
    return [
      {
        text: "No.RM/ Nama",
        value: "rm",
        align: "left",
        width: "20%"
      },
      {
        text: "Tgl Transfer",
        value: "tgl_transfer",
        align: "left",
        width: "15%"
      },
      {
        text: "Unit Asal",
        value: "unit_asal",
        align: "left",
        width: "15%"
      },
      {
        text: "Unit Tujuan",
        value: "unit_tujuan",
        align: "left",
        width: "15%"
      },
      {
        text: "Diagnosa",
        value: "diagnosa",
        align: "left",
        width: "13%"
      },
      {
        text: "Status",
        value: "status_sampai",
        align: "left",
        width: "12%"
      },
      {
        text: "Aksi",
        value: "aksi",
        align: "left",
        width: "10%"
      }
    ];
  }

  formatJam(nilai: string | null | undefined): string {
    return nilai ? moment(nilai).format("DD/MM HH:mm") : "-";
  }

  canVerifyArrival(item: any): boolean {
    if (typeof item?.can_verify_arrival === "boolean") {
      return item.can_verify_arrival;
    }
    return !item?.arrived_at && !item?.received_at;
  }

  canEditPengiriman(item: any): boolean {
    if (typeof item?.can_edit_pengiriman === "boolean") {
      return item.can_edit_pengiriman;
    }
    return (
      !item?.received_at &&
      String(item?.from_user_id) === String(this.stateuser.id)
    );
  }

  konfirmasiSampai(item: any) {
    this.arrivedTarget = item;
    this.showArrivedModal = true;
  }

  async verifSampai(password: string) {
    if (this.verifying || !this.arrivedTarget) return;
    this.verifying = true;

    try {
      await TransferInternal.arrive(
        Number(this.arrivedTarget.id),
        userModule.user.unit_id,
        password
      );
      appModule.sendSuccessNotice("Kedatangan pasien berhasil diverifikasi");
      this.showArrivedModal = false;
      this.arrivedTarget = null;
      this.loadData();
      this.$root.$emit("reload-ranap-global");
    } catch (err) {
      appModule.addMsgTtd(
        err?.response?.data?.message || "Verifikasi kedatangan gagal"
      );
    } finally {
      this.verifying = false;
    }
  }

  mounted() {
    this.loadData();
    this.checkUserAndLoad();
  }

  @Watch("selectedRegister", { immediate: true, deep: true })
  onSelectedRegisterChanged(val) {
    if (val) {
      this.loadData();
    } else {
      this.listData = [];
    }
  }

  @Watch("stateuser", { immediate: true, deep: true })
  onUserChanged(val: any) {
    if (val && val.unit_id && !this.isUserLoaded) {
      this.checkUserAndLoad();
    }
  }

  @Watch("stateuser.unit_id")
  onUnitLoginChanged(val: string) {
    if (!val) return;

    this.unit = {
      id: val,
      nama: userModule.user.unit || ""
    };
    this.loadData();
  }

  checkUserAndLoad() {
    const userId = userModule.user.unit_id;

    if (userId && !this.isUserLoaded) {
      this.isUserLoaded = true;

      this.unit = {
        id: userId,
        nama: userModule.user.unit || ""
      };

      this.loadData();
    }
  }

  async loadData() {
    this.loadingList = true;
    this.errorList = "0";
    try {
      let data: any[] = [];

      if (this.mode === "received") {
        const unitId = userModule.user.unit_id;

        if (unitId) {
          console.log("Fetching data for Unit ID:", unitId);

          const response = await TransferInternal.getByUnit(unitId);

          if (response) {
            if (response.data && Array.isArray(response.data)) {
              data = response.data;
            } else if (Array.isArray(response)) {
              data = response;
            }
          }
        } else {
          console.warn("Unit ID tidak ditemukan untuk mode received");
        }
      } else {
        const response = await TransferInternal.getByRegister(
          this.selectedRegister || 0
        );
        if (response) {
          if (Array.isArray(response)) {
            data = response;
          } else if (response.data && Array.isArray(response.data)) {
            data = response.data;
          }
        }
      }

      this.listData = data;
    } catch (error) {
      this.errorList = "1";
      console.error("Error loading transfer data:", error);
    } finally {
      this.loadingList = false;
    }
  }

  onSubmitPenerimaan() {
    this.loadData();
    this.modalPengiriman = false;
  }

  viewDetail(item: PtiDiterimaResponseItem | PtiTransferResponseItem) {
    this.selectedTransfer = item;
    this.modalPenerimaan = true;
    this.selectedId = item.id;
    if (item.received_at) {
      this.isEditMode = true;
    } else {
      this.isEditMode = false;
    }
  }

  closePenerimaan() {
    this.selectedTransfer = null;
    this.modalPenerimaan = false;
    this.selectedId = null;
    this.isEditMode = false;
  }

  openNewTransfer(item: PtiDiterimaResponseItem | PtiTransferResponseItem) {
    this.selectedTransfer = item;
    this.selectedRegister = item.register_id;
    this.selectedPasienRm = item.pasien_rm;
    this.selectedFromUnit = item.from_unit_id || item.unit_id;
    this.isEditMode = false;
    this.selectedId = item.id;
    this.modalPengiriman = true;
  }

  editTransfer(item: PtiDiterimaResponseItem | PtiTransferResponseItem) {
    this.selectedTransfer = item;
    this.selectedRegister = item.register_id;
    this.isEditMode = true;
    this.modalPengiriman = true;
  }

  closeDialog() {
    this.modalPengiriman = false;
    this.selectedTransferId = 0;
    this.isEditMode = false;
    this.loadData();
    this.selectedRegister = 0;
  }

  get stateuser() {
    const user = userModule.user;
    console.log("User Login:", user);
    return user;
  }

  get listTransfer() {
    let list = this.listData;

    if (this.unit && (this.unit as any).id) {
      const unitId = (this.unit as any).id;
      list = list.filter((item: any) => item.to_unit_id === unitId);
    }

    return list;
  }

  get counter() {
    return this.listTransfer.length;
  }

  get listUnitRanap() {
    return storeReferensiUnit.unit;
  }

  canEdit(item: PtiDiterimaResponseItem | PtiTransferResponseItem): boolean {
    return item.status === "pending";
  }

  getUnitName(unitId: string | null): string {
    if (!unitId) return "-";
    const unit = this.listUnitRanap.find((u: any) => u.id === unitId);
    return unit ? unit.nama : unitId;
  }

  setDokter(val: any) {
    this.dokter = val;
  }

  setUnit(val: any) {
    this.unit = val;
  }

  reload() {
    this.loadData();
  }

  clearFilter() {
    this.dokter = {};
    if (this.mode === "received" && userModule.user.unit_id) {
      this.unit = {
        id: userModule.user.unit_id,
        nama: userModule.user.unit || ""
      };
    } else {
      this.unit = {};
    }
  }

  getHumanDate(date: string | null) {
    if (!date) return "-";
    return moment(date).format("DD MMMM YYYY HH:mm");
  }

  formatDate(date: string) {
    return date ? moment(date).format("DD-MM-YYYY HH:mm") : "-";
  }

  getStatusColor(status: string) {
    switch (status) {
      case "pending":
        return "warning";
      case "completed":
        return "success";
      case "rejected":
        return "error";
      default:
        return "grey";
    }
  }

  openFormDetail(item: PtiDiterimaResponseItem | PtiTransferResponseItem) {
    this.selectedTransfer = item;
    this.selectedId = item.id;

    this.selectedRegister = (item as any).register_id;
    this.selectedPasienRm = (item as any).pasien_rm || (item as any).pasien?.rm;
    this.selectedFromUnit = (item as any).from_unit_id || (item as any).unit_id;

    this.$nextTick(() => {
      this.modalDetail = true;
    });
  }

  closeTransferDialog() {
    this.dialogTransfer = false;
    this.selectedTransfer = null;
    this.isEditMode = false;
  }

  onTransferSaved() {
    this.loadData();
  }

  closeModalDetail() {
    this.modalDetail = false;
  }
}
